// extracted by mini-css-extract-plugin
export var orderDetails = "_uf-2";
export var orderImage = "_uf-1";
export var orderMeta = "_uf-3";
export var orderSummary = "_uf-0";
export var rightArrow = "_uf-4";